import React, {useState} from 'react';

import {Button, Pagination, PaginationItem, PaginationLink} from "reactstrap";

import "./styles/style-duelist-pagination.scss";

export const DueListPagination = (props) => {
    const [pageNumber, setPageNumber] = useState(0);
    const [searchPagination, setSearchPagination] = useState(false);
    const openPagination = () => setSearchPagination(true);
    const closePagination = () => setSearchPagination(false);

    const { data, reload } = props;

    const maxPage = () => {
        let maxPageNumber = 0;
        
        if(data[0]){
            const fullPage = [data[0] / 40, data[0] % 40];
            maxPageNumber = fullPage[1] > 0 ? parseInt(fullPage[0]) + 1 : fullPage[0];
        }

        return maxPageNumber;
    }

    const changeInput = (e) => {
        const maxPageNumber = maxPage();
        let value = parseInt(e.target.value);
        if (!value || value < 1) value = 1;
        if (value > maxPageNumber) value = maxPageNumber;
        setPageNumber(isNaN(value) ? 1 : value);
    };

    const goToPage = () => {
        let newUrl = data[4] || "/default-url/";
    
        if (newUrl === "/default-url/") {
            console.error("Using default URL. Please check the logic to ensure 'data[4]' is set correctly.");
        }
    
        const page = isNaN(pageNumber) ? 1 : pageNumber;
    
        if (newUrl.includes("?") && newUrl.includes("page=")) {
            const urlParams = new URLSearchParams(newUrl.split("?")[1]);
            const oldPage = urlParams.get('page').toString();
            newUrl = newUrl.replace(`page=${oldPage}`, `page=${page}`);
        } else {
            newUrl = newUrl.includes("?") ? `${newUrl}&page=${page}` : `${newUrl}?page=${page}`;
        }
    
        reload(newUrl);
    };

    return data[0] > 0 ?(
        <div id="container-duelist-custom-pagination-general">
            <nav aria-label="...">
                <Pagination>
                    <PaginationItem className={data[1] && reload?'':'disabled'}>
                        <PaginationLink
                            tabIndex="-1"
                            onClick={() => reload(data[1])}
                        >
                            <i className="fa fa-angle-left"/>
                            <span className="sr-only">Previous</span>
                        </PaginationLink>
                    </PaginationItem>
                    <PaginationItem className="active">
                    <PaginationLink style={{cursor: 'default'}}>
    {data[3] ? parseInt(data[3]) : 1}
</PaginationLink>
                    </PaginationItem>
                    <PaginationItem className={data[2] && reload?'':'disabled'}>
                        <PaginationLink
                        onClick={() => reload(data[2])}>
                            <i className="fa fa-angle-right"/>
                            <span className="sr-only">Next</span>
                        </PaginationLink>
                    </PaginationItem>
                    <PaginationItem className={maxPage() > 1 ? "":"disabled"}>
                        <div id={searchPagination ? "container-duelist-custom-pagination" : "container-duelist-custom-pagination-closed"}>
                            <div id="container-duelist-custom-pagination-inputs">
                                <PaginationLink onClick={searchPagination ? closePagination : openPagination} id="pagination-link-duelist" style={{ border: "1px solid #e9ecef" }}>
                                    <i className="fa fa-search" style={{ color: "var(--primary-color)" }}/>
                                    <span className="sr-only">Search</span>
                                </PaginationLink>
                                <input type="number" min="1" value={pageNumber} onChange={changeInput} id="input-search-duelist-pagination"/>
                                <Button id="button-search-duelist-pagination" onClick={goToPage} color="primary" outline size="sm" type="button">
                                    Go
                                </Button>
                            </div>
                        </div>
                    </PaginationItem>
                </Pagination>
            </nav>
        </div>
    ): null
}
